export default __webpack_public_path__ + "static/media/website-banner-example.60f3b612.jpg";